<h2 mat-dialog-title>{{'Update_User' | translate}}</h2>
<mat-dialog-content>
    <form #updateUserForm="ngForm" (ngSubmit)="updateUserInfo()">
        <div class="form-container">
            <mat-form-field>
                <mat-label>{{'First_name' | translate}}</mat-label>
                <input matInput [(ngModel)]="user.firstName" name="firstName" required/>
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{'Last_name' | translate}}</mat-label>
                <input matInput [(ngModel)]="user.lastName" name="lastName" required/>
            </mat-form-field>
            <mat-form-field>
                <mat-label>{{'Phone_number' | translate}}</mat-label>
                <input
                    matInput
                    [(ngModel)]="user.phoneNumber"
                    name="phoneNumber"
                    required
                />
            </mat-form-field>

            <!-- User Groups Selection -->
            <fieldset class="user-group-container">
                <mat-checkbox
                    [checked]="areAllUserGroupsSelected()"
                    [indeterminate]="isSomeUserGroupSelected()"
                    (change)="toggleAllUserGroups($event.checked)"
                >
                    {{'Select All Groups' | translate}}
                </mat-checkbox>

                <ul class="mb-0 mt-5 list-unstyled">
                    <li *ngFor="let group of userGroupsList">
                        <mat-checkbox
                            [checked]="selectedUserGroups.includes(group.id)"
                            (change)="
                                toggleUserGroupSelection(
                                    group.id,
                                    $event.checked
                                )
                            "
                        >
                            {{ group.title }}
                        </mat-checkbox>
                    </li>
                </ul>
            </fieldset>
        </div>

        <div class="button-container sticky-buttons">
            <button mat-raised-button class="daxa" type="submit" [disabled]="isLoading || !updateUserForm.valid || !isUserGroupValid()">
                @if(isLoading){
                    Loading
                }@else{
                    {{'Save' | translate}}
                }
            </button>
            <button mat-raised-button color="warn" mat-dialog-close>
                {{'Cancel' | translate}}
            </button>
        </div>
    </form>

    <div
        class="alert alert-bg-danger d-flex justify-content-between align-items-center"
        role="alert"
        *ngIf="UpdateErrorMessage"
    >
        {{ UpdateErrorMessage }}
        <button
            type="button"
            class="close bg-transparent text-white p-0 border-none"
            data-dismiss="alert"
            aria-label="Close"
            (click)="closeAlert()"
        >
            <i class="ri-close-line"></i>
        </button>
    </div>
    <div
        class="alert alert-bg-success d-flex justify-content-between align-items-center"
        role="alert"
        *ngIf="UpdateSuccessMessage"
    >
        {{'User updated successfully' |  translate}}
        <button
            type="button"
            class="close bg-transparent text-white p-0 border-none"
            data-dismiss="alert"
            aria-label="Close"
            (click)="closeAlert()"
        >
            <i class="ri-close-line"></i>
        </button>
    </div>
</mat-dialog-content>
